import baseApi from "shared/networking/baseApi";
import {getMeta} from "shared/networking/tools";


const agencyEmail = getMeta('agencyEmail');


export function requestAssistance(name, state, phone, email, questions, age, loanAmount) {
    let bodyFormData = new FormData();
    bodyFormData.append('name', name);
    bodyFormData.append('state', state);
    bodyFormData.append('phone_number', phone);
    bodyFormData.append('email', email);
    if (questions) bodyFormData.append('questions', questions);
    if (age) bodyFormData.append('age', age);
    if (loanAmount) bodyFormData.append('loan_amount', loanAmount);
    bodyFormData.append('agency_email', agencyEmail);

    return baseApi.post('/applications/contact/', bodyFormData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}
